<maptio-error-page
  [iconName]="'minus-circle'"
  [shouldRedirect]="true"
  errorHeadline="You cannot see this!"
  i18n-errorHeadline
></maptio-error-page>
